(function () {

    var contentDay = document.querySelector('#card-day .content-day')
    if (!contentDay) {
        return
    }

    var form = contentDay.querySelector(':scope > .form')
    var anchor = contentDay.querySelector('.form-anchor')

    if (!form || !anchor) {
        return
    }

    var mql = window.matchMedia('(max-width: 910px)')

    function placeForm(isMobile) {
        var target = isMobile ? anchor : contentDay
        if (form.parentNode !== target) {
            target.appendChild(form)
        }
    }

    placeForm(mql.matches)
    mql.addEventListener('change', function (e) {
        placeForm(e.matches)
    })

})()
